import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@agion/ui'

interface PlaceholderPageProps {
  icon: React.ComponentType<{ className?: string }>
  titleKey: string
  descriptionKey: string
}

/**
 * Empty placeholder for analytics pages whose content is not built yet.
 * Renders the standard page header plus a "coming soon" empty state so the
 * route is navigable and on-brand before real metrics are wired in.
 */
export const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ icon: Icon, titleKey, descriptionKey }) => {
  const { t } = useTranslation('pages')

  return (
    <div className="container-standard">
      <div className="page-header">
        <div className="flex items-center gap-3">
          <Icon className="h-6 w-6 text-slate-600 dark:text-slate-400" />
          <div>
            <h1 className="page-title">{t(titleKey)}</h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">{t(descriptionKey)}</p>
          </div>
        </div>
      </div>

      <Card>
        <CardContent className="py-16 flex flex-col items-center justify-center text-center">
          <Icon className="h-10 w-10 text-slate-300 dark:text-slate-600 mb-3" aria-hidden="true" />
          <p className="text-sm text-slate-500 dark:text-slate-400">{t('business.comingSoon')}</p>
        </CardContent>
      </Card>
    </div>
  )
}
